import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/App-Context";
import axios from "axios";
import AnimatedGradientCards from "./hotAds-andEntertainment/AnimatedGradientCards";
//import BumpingRightCard from "./BumpingRightCard"; // Import your new component

const TempleGridChapelCourtYard = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);

  const [credentials, setCredentials] = useState({
    usernameOrEmail: "",
    password: "",
  });

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  // Detect scroll to trigger the background gradient shift
  const handleScroll = (e) => {
    if (e.target.scrollTop > 500) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  return (
    <div className="templegrid" onScroll={handleScroll}>
      {/* Floating Banners */}
      <div className="pink-ribbon">
        <div className="ribbon-content">
          ✦ TempleGrid ✦ Search coming soon ✦ TempleGrid
        </div>
      </div>
      <div className="orange-ribbon">
        <div className="ribbon-content">
          TempleGrid Network . Go . Overflow .
        </div>
      </div>
      <div className="red-ribbon">
        <div className="ribbon-content">
          TempleGrid Network . Go . Overflow .
        </div>
      </div>

      {/* This spacer matches the height of the 3 absolute ribbons so the blue one sits right below them initially */}
      <div style={{ height: "180px", width: "100%" }}></div>

      <div className="blue-ribbon">
        <div className="ribbon-content">
          TempleGrid Network . Go . Overflow .
        </div>
      </div>

      {/* The background class dynamically updates based on scroll position */}
      <div
        className={`templegrid-courtyard-setting ${
          isScrolled ? "shifted" : ""
        }`}
      ></div>

      <div className="templegrid-courtyard">
        <div className="templegrid-courtyard-plate">
          <div>TempleGrid user community</div>
        </div>
        <div className="templegrid-courtyard-indexVector">
          <input
            type="usernameOrEmail"
            name="usernameOrEmail"
            id="usernameOrEmail"
            value={credentials.usernameOrEmail}
            onChange={handleChange}
            placeholder="search user"
            className="templegrid-courtyard-index"
          />
        </div>
        <div>
          <Link className="zeus-buttons-link" to="/login">
            <button className="zeus-buttons">login</button>
          </Link>
        </div>
      </div>

      <div className="templegrid-courtyard-mall">
        <div className="blobBlades templegrid-courtyard-enclosureRight">
          <div>
            <h1>TempleGrid</h1>
            <h1>.tgrid</h1>
            <h2>Go . and overflow .</h2>
          </div>
        </div>

        <div style={{ clear: "both" }}></div>

        {/* New Bumping Card rendered here */}
        {/* <BumpingRightCard /> */}

        <AnimatedGradientCards />

        <div
          className="templegrid-privacy-notice"
          style={{ padding: "2rem", maxWidth: "600px", float: "right" }}
        >
          Privacy Policy . Your data will be used to submit any sort of terror
          attack if we can recognize you are a criminal . Your data may or may
          not be deleted , you have no ability to make any inference in order to
          preserve your data in any form or way . We have no responsibility to
          keep your data at any point . There's no responsibility to keep it .
          After a series of terror attacks we are still awaiting the results
          from the government responding to hijackers in the governemtn mass
          murdering countless innocents ( Camp Mystic , Crans Montana )
        </div>
      </div>
    </div>
  );
};

export default TempleGridChapelCourtYard;
